import { Trans, useTranslation } from "react-i18next";

export const Fdsnws = () => {
  const { t } = useTranslation();

  return (
    <div className="container">
      <div className="sub-container">
        <div className="txt_box">
          <span className="txt_title">
            {t("page.web-services.fdsnwsIntro.title")}
          </span>
          <ol>
            <li className="point-style">
              <Trans
                i18nKey="page.web-services.fdsnwsIntro.context.1"
                components={{
                  link1: (
                    <a
                      href="https://www.fdsn.org/"
                      target="_blank"
                      rel="noreferrer"
                    />
                  ),
                  link2: (
                    <a
                      href="https://service.iris.edu/fdsnws/"
                      target="_blank"
                      rel="noreferrer"
                    />
                  ),
                  link3: (
                    <a
                      href="https://orfeus-eu.org/data/eida/webservices/"
                      target="_blank"
                      rel="noreferrer"
                    />
                  ),
                }}
              />
            </li>
            <li className="point-style">
              <Trans
                i18nKey="page.web-services.fdsnwsIntro.context.2"
                components={{
                  link1: (
                    <a
                      href="https://docs.obspy.org/"
                      target="_blank"
                      rel="noreferrer"
                    />
                  ),
                }}
              />
            </li>
            <li className="point-style">
              {t("page.web-services.fdsnwsIntro.offitialHomepage")}:&nbsp;
              <a
                href="https://www.fdsn.org/webservices/"
                target="_blank"
                rel="noreferrer"
              >
                https://www.fdsn.org/webservices/
              </a>
            </li>
          </ol>
        </div>
        <div className="txt_box">
          <span className="txt_title">
            {t("page.web-services.kquakeFdsnwsIntro.title")}
          </span>
          <ol>
            <li className="point-style">
              {t("page.web-services.kquakeFdsnwsIntro.context.1")}
            </li>
            <li className="point-style">
              Service URL:{" "}
              <i>
                <u>https://quake.kigam.re.kr/</u>
              </i>
            </li>
            <li className="point-style">
              {t("page.web-services.kquakeFdsnwsIntro.context.2")}
            </li>
            <li className="point-style">
              <a
                href="https://data.kigam.re.kr/my-openapi/request/"
                target="_blank"
                rel="noreferrer"
              >
                {t("page.web-services.kquakeFdsnwsIntro.context.3")}
              </a>
            </li>
            <li className="point-style">
              {t("page.web-services.kquakeFdsnwsIntro.context.4")}
            </li>
          </ol>
        </div>
        <div className="txt_box">
          <span className="txt_title">
            {t("page.web-services.obspyExample.title")}
          </span>
          <ol>
            <li>{t("page.web-services.obspyExample.part1.title")}</li>
            <p style={{ borderStyle: "solid", borderWidth: 1, padding: 15 }}>
              from obspy import UTCDateTime
              <br />
              from obspy.clients.fdsn import Client
              <br />
              <br />
              client = Client("https://quake.kigam.re.kr/")
              <br />
              <br /># {t("page.web-services.obspyExample.part1.comment1")}
              <br />
              client.request_headers["X-Open-Api-Token"] = "&#60;지오빅데이터
              오픈플랫폼의 오픈API 인증키&#62;"
              <br />
              # Example: client.request_headers["X-Open-Api-Token"] =
              "aaaaabbbbbCCCCCddddd12345eeeee"
              <br />
            </p>
            <li>{t("page.web-services.obspyExample.part2.title")}</li>
            <p style={{ borderStyle: "solid", borderWidth: 1, padding: 15 }}>
              # {t("page.web-services.obspyExample.part2.comment1")}
              <br />
              inventory = client.
              <a
                href="https://docs.obspy.org/packages/autogen/obspy.clients.fdsn.client.Client.get_stations.html"
                target="_blank"
                rel="noreferrer"
              >
                get_stations
              </a>
              (level="response")
              <br /># {t("page.web-services.obspyExample.part2.comment2")}
              <br />
              <br /># {t("page.web-services.obspyExample.part2.comment3")}{" "}
              <br />
              inventory_AJD = client.get_stations(station="AJD",
              level="response")
              <br />
              <br /># {t("page.web-services.obspyExample.part2.comment4")}
              <br />
              inventory_H_Z = client.get_stations(channel="H?Z",
              level="response")
              <br />
              <br /># {t("page.web-services.obspyExample.part2.comment5")}
              <br />
              inventory.
              <a
                href="https://docs.obspy.org/master/packages/autogen/obspy.core.inventory.inventory.Inventory.write.html"
                target="_blank"
                rel="noreferrer"
              >
                write
              </a>
              ("KIGAM_KG61_metadata.xml", format="STATIONXML")
              <br />
            </p>
            <li>{t("page.web-services.obspyExample.part3.title")}</li>
            ※ <Trans i18nKey="page.web-services.obspyExample.part3.desc" />
            <p style={{ borderStyle: "solid", borderWidth: 1, padding: 15 }}>
              event_time = UTCDateTime("2016-09-12T11:32:54")
              <br /># {t("page.web-services.obspyExample.part3.comment1")}
              <br />
              stream = client.
              <a
                href="https://docs.obspy.org/packages/autogen/obspy.clients.fdsn.client.Client.get_waveforms.html"
                target="_blank"
                rel="noreferrer"
              >
                get_waveforms
              </a>
              ("*", "*", "*", "B?Z", event_time, event_time + 300)
              <br />#{" "}
              <Trans
                i18nKey="page.web-services.obspyExample.part3.comment2"
                components={{
                  link1: (
                    <a
                      href="https://docs.obspy.org/packages/autogen/obspy.core.stream.Stream.plot.html"
                      target="_blank"
                      rel="noreferrer"
                    />
                  ),
                }}
              />
              <br />
              <br />
              # Bulk download
              <br />
              bulk = [<br />
              &nbsp;&nbsp;&nbsp;&nbsp;("KG", "*", "*", "B?Z", event_time,
              event_time + 300),
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;("KG", "*", "*", "BGZ",
              UTCDateTime("2017-01-01T00:00:00"),
              UTCDateTime("2017-01-01T23:59:59.999999")),
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;("KG", "*", "*", "BHZ",
              UTCDateTime("2018-01-01T00:00:00"),
              UTCDateTime("2018-01-01T23:59:59.999999")),
              <br />
              ]<br />
              stream_bulk = client.
              <a
                href="https://docs.obspy.org/packages/autogen/obspy.clients.fdsn.client.Client.get_waveforms_bulk.html"
                target="_blank"
                rel="noreferrer"
              >
                get_waveforms_bulk
              </a>
              (bulk)
              <br />#{" "}
              <Trans
                i18nKey="page.web-services.obspyExample.part3.comment3"
                components={{
                  link1: (
                    <a
                      href="https://docs.obspy.org/packages/autogen/obspy.core.stream.Stream.write.html"
                      target="_blank"
                      rel="noreferrer"
                    />
                  ),
                }}
              />
              <br />
            </p>
            <li>{t("page.web-services.obspyExample.part4.title")}</li>※{" "}
            <Trans
              i18nKey="page.web-services.obspyExample.part4.desc"
              components={{
                link1: (
                  <a
                    href="https://docs.obspy.org/packages/autogen/obspy.core.trace.Trace.remove_response.html"
                    target="_blank"
                    rel="noreferrer"
                  />
                ),
              }}
            />
            <p style={{ borderStyle: "solid", borderWidth: 1, padding: 15 }}>
              # {t("page.web-services.obspyExample.part4.comment1")}
              <br />
              inventory = client.get_stations(level="response")
              <br /># {t("page.web-services.obspyExample.part4.comment2")}
              <br />
              <br /># {t("page.web-services.obspyExample.part4.comment3")}
              <br />
              stream = client.get_waveforms(
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;"*", "*", "*", "BGZ", <br />
              &nbsp;&nbsp;&nbsp;&nbsp;UTCDateTime("2016-09-12T11:32:54"),
              UTCDateTime("2016-09-12T11:42:54")
              <br />
              )<br />
              <br /># {t("page.web-services.obspyExample.part4.comment4")}
              <br />
              sensitivity_removed_stream = stream.copy().
              <a
                href="https://docs.obspy.org/packages/autogen/obspy.core.stream.Stream.remove_sensitivity.html"
                target="_blank"
                rel="noreferrer"
              >
                remove_sensitivity
              </a>
              (inventory)
              <br /># {t("page.web-services.obspyExample.part4.comment5")}
              <br /># {t("page.web-services.obspyExample.part4.comment6")}
              <br />
              <br /># {t("page.web-services.obspyExample.part4.comment7")}
              <br />
              response_removed_stream = stream.copy().
              <a
                href="https://docs.obspy.org/packages/autogen/obspy.core.trace.Trace.remove_response.html"
                target="_blank"
                rel="noreferrer"
              >
                remove_response
              </a>
              (inventory, output="ACC")
              <br />
            </p>
            <li>{t("page.web-services.obspyExample.part5.title")}</li>※{" "}
            {t("page.web-services.obspyExample.part5.desc1")}
            <br />
            <Trans
              i18nKey="page.web-services.obspyExample.part5.desc2"
              components={{
                link1: (
                  <a
                    href="https://docs.obspy.org/packages/autogen/obspy.core.stream.Stream.remove_sensitivity.html"
                    target="_blank"
                    rel="noreferrer"
                  />
                ),
                link2: (
                  <a
                    href="https://docs.obspy.org/packages/autogen/obspy.core.stream.Stream.remove_response.html"
                    target="_blank"
                    rel="noreferrer"
                  />
                ),
              }}
            />
            <br />
            <Trans i18nKey="page.web-services.obspyExample.part5.desc3" />
            <p style={{ borderStyle: "solid", borderWidth: 1, padding: 15 }}>
              from obspy import Stream, Inventory
              <br />
              <br />
              <br />
              def extract_metadata_exist_stream(stream: Stream, inventory:
              Inventory) -&gt; Stream:
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;metadata_exist_stream = Stream()
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;for trace in stream:
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;channel_metadata =
              inventory.select(
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;trace.stats.network,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;trace.stats.station,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;trace.stats.location,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;trace.stats.channel,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;)
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;if
              len(channel_metadata):
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;for
              metadata in channel_metadata[0][0]:
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;trimmed_trace
              = trace.copy().trim(metadata.start_date, metadata.end_date)
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;if
              trimmed_trace:
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;metadata_exist_stream.append(trimmed_trace)
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;return metadata_exist_stream
              <br />
              <br />
              <br /># {t("page.web-services.obspyExample.part5.comment1")}
              <br />
              inventory = client.get_stations(level="response")
              <br />
              <br /># {t("page.web-services.obspyExample.part5.comment2")}
              <br />
              stream = client.get_waveforms(
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;"*", "*", "*", "BGZ", <br />
              &nbsp;&nbsp;&nbsp;&nbsp;UTCDateTime("2016-09-12T11:32:54"),
              UTCDateTime("2016-09-12T11:42:54")
              <br />
              )<br />
              <br /># {t("page.web-services.obspyExample.part5.comment3")}
              <br />
              metadata_exist_stream = extract_metadata_exist_stream(stream,
              inventory)
              <br />
              <br /># {t("page.web-services.obspyExample.part5.comment4")}
              <br />
              sensitivity_removed_stream = metadata_exist_stream.copy().
              <a
                href="https://docs.obspy.org/packages/autogen/obspy.core.stream.Stream.remove_sensitivity.html"
                target="_blank"
                rel="noreferrer"
              >
                remove_sensitivity
              </a>
              (inventory)
              <br />
              <br /># {t("page.web-services.obspyExample.part5.comment5")}
              <br />
              response_removed_stream = metadata_exist_stream.copy().
              <a
                href="https://docs.obspy.org/packages/autogen/obspy.core.trace.Trace.remove_response.html"
                target="_blank"
                rel="noreferrer"
              >
                remove_response
              </a>
              (inventory, output="ACC")
              <br />
            </p>
            <li className="point-style">
              {t("w.references")}
              <ol>
                <li>
                  <a
                    href="https://docs.obspy.org/tutorial/code_snippets/retrieving_data_from_datacenters.html"
                    target="_blank"
                    rel="noreferrer"
                  >
                    ObsPy Tutorial(Retrieving Data from Data Centers)
                  </a>
                </li>
                <li>
                  <a
                    href="https://docs.obspy.org/packages/obspy.clients.fdsn.html"
                    target="_blank"
                    rel="noreferrer"
                  >
                    ObsPy API Document(FDSN web service client for ObsPy)
                  </a>
                </li>
              </ol>
            </li>
          </ol>
        </div>
      </div>
    </div>
  );
};
